import React from 'react'
import { useTranslation } from 'react-i18next'

import { FooterSection } from './FooterSection'
import { FooterMeta, FooterMetaList } from './FooterMeta'
import { FooterFeedback } from './FooterFeedback'

type Props = {
    sections: FooterSection[]
    metaList: FooterMetaList[]
    showFeedback?: boolean
}

export const Footer: React.FC<Props> = ({ sections, metaList, showFeedback = false }) => {
    const { t } = useTranslation()

    return (
        <footer className="idsk-footer-extended" aria-label={t('footer.label')}>
            {showFeedback && <FooterFeedback />}
            <div className="govuk-width-container ">
                <div className="govuk-footer__navigation">
                    {sections.map((section, index) => (
                        <FooterSection key={index} itemList={section.itemList} header={section.header} columnsCount={section.columnsCount} />
                    ))}
                </div>
                <hr className="govuk-footer__section-break" />
                <FooterMeta metaList={metaList} />
            </div>
        </footer>
    )
}
